import { render } from "./ParquedoAgreste.vue?vue&type=template&id=5f6a9d14"
import script from "./ParquedoAgreste.vue?vue&type=script&lang=js"
export * from "./ParquedoAgreste.vue?vue&type=script&lang=js"

import "./ParquedoAgreste.vue?vue&type=style&index=0&id=5f6a9d14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__